// extracted by mini-css-extract-plugin
module.exports = {"component":"CartRow_component__T3qEm","removeButton":"CartRow_removeButton__AUGUX"};